import { Drawer, List, ListItem, ListItemIcon, ListItemText, Toolbar } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import CollectionsBookmarkOutlinedIcon from '@material-ui/icons/CollectionsBookmarkOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
import RecentActorsOutlinedIcon from '@material-ui/icons/RecentActorsOutlined';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Icon } from 'components/AORedesign';
import featureFlags from 'constants/featureFlags';
import {
  ROUTE_BILLING,
  ROUTE_CLAIMS,
  ROUTE_CLIENTS,
  ROUTE_DASH,
  ROUTE_EMPLOYEE_HOME,
  ROUTE_QUOTES,
  ROUTE_REDESIGN_REPORTS,
  ROUTE_REDESIGN_RESOURCES,
} from '../../constants/routes';
import { Feature } from '../Feature';

const drawerLength = 72;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerLength,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerLength,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  navItem: {
    color: theme.palette.text.secondary,
    height: drawerLength,
    width: drawerLength,
    paddingTop: '0.8125rem',
    paddingBottom: '0.8125rem',
    flexDirection: 'column',
    position: 'relative',
  },
  navIcon: {
    justifyContent: 'center',
  },
  navSelected: {
    color: theme.palette.primary.main,

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      width: '0.25rem',
      backgroundColor: theme.palette.primary.main,
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
  },
  navLabel: {
    fontSize: '0.75rem',
  },
}));

const navigationItems = [
  {
    text: 'Home',
    featureFlag: featureFlags.ACCESS_USER_INTERNAL,
    route: ROUTE_EMPLOYEE_HOME,
    icon: <HomeOutlinedIcon />,
  },
  {
    text: 'Dashboard',
    featureFlag: '',
    route: ROUTE_DASH,
    icon: <DashboardOutlinedIcon />,
  },
  { text: 'Clients', featureFlag: '', route: ROUTE_CLIENTS, icon: <RecentActorsOutlinedIcon /> },
  { text: 'Quotes', featureFlag: '', route: ROUTE_QUOTES, icon: <Icon iconName="icons-icon-request-quote" /> },
  {
    text: 'Billing',
    featureFlag: '',
    route: ROUTE_BILLING,
    icon: <PaymentOutlinedIcon />,
  },
  {
    text: 'Claims',
    featureFlag: '',
    route: ROUTE_CLAIMS,
    icon: <AssignmentOutlinedIcon />,
  },
  {
    text: 'Reports',
    featureFlag: '',
    route: ROUTE_REDESIGN_REPORTS,
    icon: <AssessmentOutlinedIcon />,
  },
  {
    text: 'Resources',
    featureFlag: '',
    route: ROUTE_REDESIGN_RESOURCES,
    icon: <CollectionsBookmarkOutlinedIcon />,
  },
];

const Navigation = () => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}>
      <Toolbar />
      <div className={classes.drawerContainer}>
        <List>
          {navigationItems.map((item) => {
            const isNavItemSelected = (pathname.split('/')[1] || pathname) === (item.route.split('/')[1] || item.route);

            const renderItem = () => (
              <ListItem
                id={`ao-nav-${item.text.toLowerCase()}`}
                button
                classes={{ root: classes.navItem, selected: classes.navSelected }}
                key={`ao-li-${item.text}`}
                onClick={() => history.push(item.route)}
                selected={isNavItemSelected}>
                <ListItemIcon className={classes.navIcon}>{React.cloneElement(item.icon, { color: isNavItemSelected ? 'primary' : 'inherit' })}</ListItemIcon>
                <ListItemText classes={{ primary: classes.navLabel }} primary={item.text} />
              </ListItem>
            );

            return item.featureFlag ? (
              <Feature allowed={item.featureFlag} key={`ao-ff-li-${item.text}`}>
                {renderItem()}
              </Feature>
            ) : (
              renderItem()
            );
          })}
        </List>
      </div>
    </Drawer>
  );
};

export default Navigation;
